import React from 'react';
import { useAppSelector } from '../../store/hooks';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

interface AdminPaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const AdminPagination: React.FC<AdminPaginationProps> = ({ page, totalPages, onPageChange }) => {
  const colors = useAppSelector((state) => state.theme.theme);

  if (totalPages <= 1) return null;

  return (
    <div className="flex items-center justify-center gap-2 mt-4">
      <button
        onClick={() => onPageChange(Math.max(1, page - 1))}
        disabled={page <= 1}
        className="p-2 rounded-lg disabled:opacity-30"
        style={{ backgroundColor: colors.inputBackground }}
      >
        {React.createElement(FiChevronLeft as any, { size: 16, color: colors.textColor })}
      </button>
      <span className="text-sm px-3" style={{ color: colors.grayScale500 }}>
        {page} / {totalPages}
      </span>
      <button
        onClick={() => onPageChange(Math.min(totalPages, page + 1))}
        disabled={page >= totalPages}
        className="p-2 rounded-lg disabled:opacity-30"
        style={{ backgroundColor: colors.inputBackground }}
      >
        {React.createElement(FiChevronRight as any, { size: 16, color: colors.textColor })}
      </button>
    </div>
  );
};

export default AdminPagination;
